import React from 'react'
import './Footer.css';

function Footer() {
  return (
    <div className="footer-container">
        <h3>Made with React.js 🌎 </h3>

    </div>
  )
}

export default Footer